<template>
  <font-awesome-icon
    icon="calendar-check"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'

library.add(faCalendarCheck)

export default {
  name: 'CoozzyCalendarCheckIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
